import BaseAPI from './base/base-api';

class RemoteSigningAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'ManagementAPI';
    controllerName = 'remotesigning';
}

export default new RemoteSigningAPI();